<template>
  <Details v-if="!isLoading && !isMounting"
           style="overflow-y: auto; height: 100%;" />
</template>

<script setup>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useWidgetNavigator } from '@/components/widgets/composables/useWidgetNavigator'
import { useFetch } from '@/components/widgets/composables/useFetchContent'
import { useSearch } from '@/components/widgets/composables/useSearch'
import Details from '@/components/library/content/details/Details.vue'

const store = useStore()
const { productPage } = useWidgetNavigator()
const { fetchDecorator, isLoading } = useFetch()
const { logSearchClickThrough } = useSearch()
const isMounting = ref(true)

async function syncProductPageWithVuex() {
  if (!productPage.value) {
    return
  }

  await store.dispatch('content/getContent', {
    id: String(productPage.value.id),
    type: 'productpage'
  })

  await store.dispatch('content/getTags', {
    filter: '',
    id: store.state.content.id,
    type: store.state.content.type
  })
}

/**
 * Watch for product page changes to re-sync Vuex state.
 * This handles cases where the user navigates back to the product page
 * from related media or when the product page is refreshed.
 */
watch(
  () => productPage.value?.id,
  async () => {
    if (!productPage.value) {
      return
    }

    isMounting.value = true
    await fetchDecorator(syncProductPageWithVuex)()
    await logSearchClickThrough()
    isMounting.value = false
  },
  { immediate: true }
)
</script>
